<template>
    <div class="d-flex align-items-center flex-wrap">
        <bs-button class="btn-sm btn-warning ml-2" @click="$router.push({ path: '/customer/' + customer })">{{ $t('labels.overview') }}</bs-button>
        <bs-button v-if="auth.can['customer_schedules']" class="btn-sm btn-warning ml-2" @click="$router.push({ path: '/customer/' + customer + '/schedules' })">{{ $t('labels.schedule') }}</bs-button>
        <bs-button v-if="auth.can['customer_properties']" class="btn-sm btn-warning ml-2" @click="$router.push({ path: '/customer/' + customer + '/properties' })">{{ $t('labels.properties') }}</bs-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'NavSecondaryCustomer',
  props: ['customer'],
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  }
}
</script>
